import RotateLeftIcon from '@mui/icons-material/RotateLeft';
import {
  Avatar,
  Box,
  MenuItem,
  Select,
  Stack,
  Tooltip,
  Typography
} from "@mui/material";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableSortLabel from "@mui/material/TableSortLabel";
import { visuallyHidden } from "@mui/utils";
import * as React from "react";
import DateRangePickerComponent from "../../../components/date/DateRangePickerComponent";
import { useDispatch, useSelector } from "react-redux";
import useDebounce from "../../../hooks/use.debounce";
import { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { io } from "socket.io-client";
import { CustomModal } from "../../../components/campaignModal";
import CommonModel from "../../../components/dialog/Common";
import { capitalizeFirstLetter, DELIVERABLES_DATA, formatDate, formatPrice, getFormatedDate, SELECTED_DELI, SELECTED_DELI_FOR_YOUTUBE } from "../../../utils/common";
import { BASE_URL, CAMPAIGN_STATUS, CAMPAIGN_TYPES, CAMPAIGNS_STATUS_CARD, CustomSearchInput, DRAFT, FORM_SELECTFIELD_STYLES, GENDER, LIVE, PENDING, REJECTED, RUPEES_SYMBOL, SOCKET_EVENT, START_ADORNMENT_FOR_CUSTOM_SEARCH_INPUT, TABLE_BODY_ROW_MUI_STYLES, TABLE_HEADER_ROW_MUI_STYLES } from "../../../utils/constant";
import { endpoints } from "../../../utils/endpoints";
import { getAllBrandsforListing } from "../../brands/action";
import { getAllCompanyforDropdown } from "../../company/action";
import { deleteCampaign, getAllCampaigns, getCampaignByIdForDetailsPage } from "../action";
import { updateCampaign } from "../campaignSlice";
import CustomPagination from "../../../utils/CustomPagination";

function EnhancedTableHead(props) {
  const { order, orderBy } = props;

  const headCells = [
    {
      id: "name",
      numeric: false,
      disablePadding: true,
      label: "Campaign Name",
      type: "",
    },
    {
      id: "brand",
      numeric: false,
      disablePadding: true,
      label: "Company",
      type: "",
    },
    {
      id: "start_date",
      numeric: false,
      disablePadding: true,
      label: "Start Date",
      type: "",
    },
    {
      id: "end_date",
      numeric: false,
      disablePadding: true,
      label: "End Date",
      type: "",
    },
    {
      id: "goalOfCampaign",
      numeric: false,
      disablePadding: true,
      label: "Goal of the Campaign",
      type: "",
    },
    {
      id: "Budget ",
      numeric: false,
      disablePadding: true,
      label: "Budget",
      type: "",
    },
    {
      id: "influencer_type",
      numeric: false,
      disablePadding: true,
      label: "Influencer Type",
      type: "",
    },
    {
      id: "status",
      numeric: false,
      disablePadding: true,
      label: "Status",
      type: "",
    },
    {
      id: "action",
      numeric: false,
      disablePadding: true,
      label: "Action",
      type: "",
    },
  ];
  return (
    <TableHead className="hideActionSort">
      <TableRow sx={TABLE_HEADER_ROW_MUI_STYLES}>
        {headCells.map((headCell) => {
          return (
            <TableCell
              key={headCell?.id}
              align={"left"}
              padding={headCell.disablePadding ? "none" : "normal"}
              sortDirection={orderBy === headCell.id ? order : false}
            >
              <TableSortLabel
                active={orderBy === headCell.id}
                direction={orderBy === headCell.id ? order : "asc"}
                IconComponent={() => null}>
                {headCell.label}
                {orderBy === headCell.id ? (
                  <Box component="span" sx={visuallyHidden}>
                    {order === "desc"
                      ? "sorted descending"
                      : "sorted ascending"}
                  </Box>
                ) : null}
              </TableSortLabel>
            </TableCell>
          );
        })}
      </TableRow>
    </TableHead>
  );
}

const socket = io(BASE_URL + endpoints.ims, {
  path: '/stream',
  transports: ['websocket']
});

export default function Listing() {
  const navigate = useNavigate();
  const states = useSelector((state) => state.app);
  const [order, setOrder] = React.useState("asc");
  const [orderBy, setOrderBy] = React.useState("name");
  const [deleteOpen, setDeleteOpen] = React.useState(0);
  const tableRef = React.useRef();

  const dispatch = useDispatch();
  const {
    limit,
    page,
    sort_key,
    totalPages,
    listing: campaignListing,
    filters,totalCount,
    routing,allStatusCount
  } = useSelector((state) => state.campaignSlice);
  const debouncedSearch = useDebounce(filters.search, 500);


  const {
    companyDrodown: companyListing
  } = useSelector((state) => state.companySlice);

  const {
    brandsDropdown,
  } = useSelector((state) => state.brandSlice);

  const {
    deliverablesPlatform
  } = useSelector((state) => state.commonSlice);

  const [open, setOpen] = React.useState(false);
  const [modal, setModal] = React.useState({
    heading: "",
    submitButton: "",
    isError: false,
  });

  const handleChangePerPage = (event, value) => {
    dispatch(updateCampaign({ limit: event.target.value, page: 0 }));
    dispatch(getAllCampaigns());
  };

  const handleChange = (value) => {
    dispatch(updateCampaign({ page: value - 1 }));
    dispatch(getAllCampaigns());
  };


  const handleRequestSort = (
    event,
    property
  ) => {
    const isAsc = orderBy === property && order === "asc";

    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
    dispatch(
      updateCampaign({
        sort_type: isAsc ? "asc" : "desc",
        sort_key: property,
      }),
    );
    dispatch(getAllCampaigns());
  };

  useEffect(() => {
    if (debouncedSearch || filters.search == "")
      dispatch(getAllCampaigns());

  }, [debouncedSearch]);



  useEffect(() => {
    if (routing == "audit") {
      dispatch(updateCampaign({ limit: 10, page: 0, filters: { ...filters }, routing: "" }));
    } else {
      dispatch(updateCampaign({ limit: 10, page: 0, filters: {} }));
    }

    dispatch(getAllBrandsforListing())
    dispatch(getAllCompanyforDropdown())
    dispatch(getAllCampaigns());
  }, []);

  const handleSearch = (event) => {
    dispatch(updateCampaign({ filters: { ...filters, search: event.target.value }, page: 0 }));
  };

  useEffect(() => {
    const handleCampaignCreated = () => {
      return dispatch(getAllCampaigns());
    };

    const handleCampaignApproved = () => {
      return dispatch(getAllCampaigns());
    };

    socket.on(SOCKET_EVENT.CAMPAIGN_CREATED, handleCampaignCreated);
    socket.on(SOCKET_EVENT.CAMPAIGN_APPROVED, handleCampaignApproved);
    return () => {
      socket.off(SOCKET_EVENT.CAMPAIGN_CREATED, handleCampaignCreated);
      socket.off(SOCKET_EVENT.CAMPAIGN_APPROVED, handleCampaignApproved);
    };
  }, []);



  const handleSearchClear = () => {

    dispatch(updateCampaign({ filters: { ...filters, search: "" } }));
    dispatch(getAllCampaigns());
  };

  const handleSubmit = ({ companyId }) => {
    dispatch(updateCampaign({ invitedIds: [], invitedInfluencers: [] }));
    navigate("/campaign/type", { state: companyId })
  }

  const approveFunction = () => {
    setOpen(true);
    setModal({
      heading: "Company Name",
      submitButton: "Next",
    });
  };

  const updateFormData = (row) => {
    dispatch(getCampaignByIdForDetailsPage(row.id, (data) => {
      dispatch(updateCampaign({ campaignAppliedCount: data?.campaignContent?.filter((v) => v?.campaignContentJourney?.Script != null) }));
      delete data.campaignContent;
      delete data.applied;
      delete row.campaignContent;
      delete row.applied;
      let rowData = data;
      rowData.campaignId = row.id;

      const selectedDeliverables = rowData?.deliverables?.length > 0 ? (rowData?.deliverables[0]?.plateform == "youtube" ? SELECTED_DELI_FOR_YOUTUBE : SELECTED_DELI).map((vv) => {
        let val = data?.deliverables?.map((v) => v.deliverables)[0]?.find((v) => v?.type == vv?.type);
        if (val) {
          return { ...val };
        } else {
          return vv;
        }
      }) : [];

      rowData.platform = rowData?.deliverables?.length > 0 ? rowData?.deliverables[0]?.plateform : "";
      rowData.selectedDeliverables = rowData?.deliverables?.length > 0 ? selectedDeliverables : [];
      rowData.post = rowData?.deliverables?.length > 0 ? data?.deliverables[0]?.post : [];
      rowData.deliverables = rowData?.deliverables?.length > 0 ? DELIVERABLES_DATA.find((v) => v[`${rowData.deliverables[0].plateform}`])[`${rowData.deliverables[0].plateform}`] : [];
      rowData.brandId = row.brand.id || '';
      rowData.additionalRequirement = rowData.additionalRequirement !== "null" ? rowData.additionalRequirement : "";
      rowData.startDate = rowData.startDate ? formatDate(rowData.startDate) : null;
      rowData.endDate = rowData.endDate ? formatDate(rowData.endDate) : null;
      rowData.budgetbudgetPerInfluencer = rowData.budgetPerInfluencer;
      rowData.bannerImage = row?.bannerImage?.toString() || '';
      rowData.gender = rowData?.creator?.gender || "";
      rowData.creatorLocation = rowData?.creator?.creatorLocation || '';
      rowData.influncerType = rowData?.creator?.influncerType || "";
      rowData.selectedCategories = rowData?.creator?.selectedCategories || [];
      rowData.campaignApplyingPreferences = rowData?.creator?.campaignApplyingPreferences ? ['campaignApplyingPreferences'] : [];
      rowData.noOfCreators = String(rowData?.noOfCreators || "");
      rowData.brandLogo = rowData.brandLogo || '';
      rowData.shipmentDetails = rowData.shipmentDetails ? ['shipmentDetails'] : []
      rowData.productShipmentDate = rowData.productShipmentDate ? formatDate(rowData.productShipmentDate) : "";
      rowData.conceptScriptDate = rowData?.conceptScriptDate ? formatDate(rowData?.conceptScriptDate) : null;
      rowData.contentSubmissionDate = rowData?.contentSubmissionDate ? formatDate(rowData?.contentSubmissionDate) : null
      rowData.contentPublishDate = rowData?.contentPublishDate ? formatDate(rowData?.contentPublishDate) : null;
      rowData.mode = "edit";
      rowData.productDropdown = brandsDropdown?.find((v) => v.id === rowData.brandId)?.product?.map((v) => v?.name) || [];
      dispatch(updateCampaign({ affliateSection: 0, deliverablesSection: 0, addtionalSection: 0, detailsSection: 0, formData: rowData, searchedInfluencers: [], searchedInfluencersCheckboxIds: [], searchedInfluencersInvitedIds: [], suggestedInfluencers: [] }));
      navigate(`/campaign/info`)
    }));
  }

  return (
    <>
      <Stack direction={"column"} gap={2}>
        <Stack
          className="mainTitle  flex-wrap"
          direction={"row"}
          alignItems={"center"}
          gap={2}
          justifyContent={"space-between"}
          sx={{
            minHeight: '42px', paddingX: '16px'
          }}
        >
          <Typography className="page-title" variant="h1">Campaign Management</Typography>
           <button className="btnPrimary"
              disabled={!states?.permissions?.campaign?.create}
              onClick={() => {
                dispatch(updateCampaign({ formData: {}, affliateSection: 0, deliverablesSection: 0, addtionalSection: 0, detailsSection: 0, searchedInfluencers: [], searchedInfluencersCheckboxIds: [], searchedInfluencersInvitedIds: [], suggestedInfluencers: [] }))
                approveFunction();
              }}
            >
              Create Campaign
            </button>
          {/* <Stack direction="row" justifyContent="flex-end" alignItems="center" gap={2} flexWrap="wrap">
          
           

          </Stack> */}
        </Stack>
  <Stack direction="row" justifyContent="flex-start" gap={3} flexWrap="wrap" sx={{padding:'24px 16px'}}>
        {CAMPAIGNS_STATUS_CARD?.map((card)=>(
          <Box sx={{width:'265px',height:'120px',borderRadius:'10px',padding:'10px 16px',boxShadow:'0px 0px 24px 0px rgba(0, 0, 0, 0.10)',background:'#fff'}}>
            <Stack justifyContent="center" alignItems="center" sx={{width:'32px',height:'32px',boxShadow:'0px 0px 5px 0px rgba(0, 0, 0, 0.08)',borderRadius:'4px',marginBottom:'12px'}}>
              <img src={card.icon} alt={card.icon} style={card.key === 'totalCount' ? {  height:'28px',width:'28px' }: {width:'24px',height:'24px'}}/>
            </Stack>
            <Typography sx={{fontWeight:700,fontSize:'20px',color:'black',marginBottom:'5px'}}>{allStatusCount?.[card.key] || 0}</Typography>
            <Typography sx={{fontWeight:400,fontSize:'14px',color:'#726C6C',}}>{card.name}</Typography>
          </Box>
        ))}
        </Stack>
         <Stack direction="row" justifyContent="space-between" sx={{ paddingX: '16px' }}>
            <CustomSearchInput
              className="inputSearch sContrl p-0"
              value={filters.search}
              placeholder={"Search here..."}
              handleSearch={handleSearch}
              clearSearch={handleSearchClear}
              startAdornment={START_ADORNMENT_FOR_CUSTOM_SEARCH_INPUT}
            />
          <Stack direction="row" justifyContent="flex-end" alignItems="center" gap={2} flexWrap="wrap">
 <DateRangePickerComponent text="Date Range" getSelectedDate={(dates) => {
              if (dates?.filter((v) => v)?.length === 2) {
                dispatch(updateCampaign({ filters: { ...filters, startDate: getFormatedDate(dates[0]), endDate: getFormatedDate(dates[1]) } }));
                dispatch(getAllCampaigns());
              }

            }} dateReset={filters} startDate1={filters?.startDate} endDate1={filters?.endDate} />
            <Select
              sx={{ ...FORM_SELECTFIELD_STYLES, maxHeight: '48px', maxWidth: '200px', width: '200px' }}
              MenuProps={{
                PaperProps: {
                  sx: {
                    borderRadius: "8px",
                    mt: 1,
                  },
                },
              }}
              value={filters?.status || ''}
              name="status"
              onChange={(e) => {
                dispatch(updateCampaign({ filters: { ...filters, status: e.target.value } }));
                dispatch(getAllCampaigns());
              }} displayEmpty
              defaultValue={filters?.status || ''}
              justifyContent={"flex-end"}
              className="upperCase"
            >
              <MenuItem disabled value="" hidden>
                Status
              </MenuItem>
              <MenuItem value=" " >
                Status (All)
              </MenuItem>
              {CAMPAIGN_STATUS.map((v) => <MenuItem key={v} value={v} >
                {v}
              </MenuItem>)}
            </Select>
            <Select
              sx={{ ...FORM_SELECTFIELD_STYLES, maxHeight: '48px', maxWidth: '200px', width: '200px' }}
              MenuProps={{
                PaperProps: {
                  sx: {
                    borderRadius: "8px",
                    mt: 1,
                  },
                },
              }}
              value={filters?.type || ""}
              name="type"
              onChange={(e) => {
                dispatch(updateCampaign({ filters: { ...filters, type: e.target.value } }))
                dispatch(getAllCampaigns());
              }}
              displayEmpty
              defaultValue={""}
              justifyContent={"flex-end"}
              className="upperCase">
              <MenuItem disabled value="" hidden>
                Type
              </MenuItem >
              <MenuItem value=" " >
                Type (All)
              </MenuItem>
              {Object.values(CAMPAIGN_TYPES).map((v) => <MenuItem className="upperCase" key={v} value={capitalizeFirstLetter(v)} >
                {capitalizeFirstLetter(v)}
              </MenuItem>)}
            </Select>
            <Tooltip title="Refresh listing">
              <RotateLeftIcon toolTip="Refresh page" size="small" sx={{ cursor: "pointer", color: '#6C7692' }}
                onClick={() => {
                  dispatch(updateCampaign({ filters: {} }))
                  dispatch(getAllCampaigns());
                }} />
            </Tooltip>

          </Stack>
         </Stack>
        <Box
          sx={{
            backgroundColor: '#fff',
            transition: 'all .5s ease-in-out',
            position: 'relative',
            overflow: 'none',
          }}>
          <CustomModal
            open={open}
            onClose={() => setOpen(!open)}
            modal={modal}
            approveFn={handleSubmit}
            companyData={companyListing}
          />
          <TableContainer ref={tableRef}>
            <Table
              aria-label="sticky table">
              <EnhancedTableHead
                order={order}
                orderBy={sort_key}
                onRequestSort={handleRequestSort}
                numSelected={0}
                onSelectAllClick={function (

                ) {
                  throw new Error("Function not implemented.");
                }}
              />
              <TableBody>
                {campaignListing && campaignListing?.length ? (
                  campaignListing?.map((row) => {
                    return (
                      <TableRow
                        hover
                        role="checkbox"
                        tabIndex={-1}
                        key={row?.id}
                        sx={TABLE_BODY_ROW_MUI_STYLES}>

                        <TableCell component="td" scope="row" sx={{ minHeight: "auto" }} className=" align-items-center" padding="none">
                          <Stack direction={"row"} >
                            <Avatar
                              alt={row?.name}
                              src={row.bannerImage.length > 0 ? row?.bannerImage?.toString() : ""}
                              sx={{ height: '35px', width: '35px', borderRadius: "50%" }}
                            />
                            <Link className="text-decoration-none text-capitalize" style={{ fontSize: '13px', fontWeight: '500', letterSpacing: '0px', marginLeft: '8px', marginTop: 4 }} onClick={(e) => {
                              e.preventDefault();
                              navigate(`/campaign/details/${row.id}`, { state: row });
                            }} >{row?.name || "N/A"}</Link>
                          </Stack>
                        </TableCell>
                        <TableCell component="td" scope="row" padding="none">
                          {row?.brand?.companyName || "N/A"}
                        </TableCell>
                        <TableCell component="td" scope="row" padding="none">
                          {row?.startDate ? getFormatedDate(row?.startDate, "MM/DD/YYYY") : "N/A"}
                        </TableCell>
                        <TableCell align="left">
                          {row?.endDate ? getFormatedDate(row?.endDate, "MM/DD/YYYY") : "N/A"}
                        </TableCell >
                        <TableCell component="td" scope="row" padding="none">
                          {row?.demand || "N/A"}
                        </TableCell>
                        <TableCell component="td" scope="row" padding="none">
                          {RUPEES_SYMBOL + (row?.budget ? formatPrice(row?.budget) : 0)}
                        </TableCell>


                        <TableCell align="left" className="single-line">
                          {row?.creator?.influncerType?.toString() || "N/A"}
                        </TableCell>
                        <TableCell align="left">
                          <button className={row.status?.toLowerCase() + " capitalize-first-letter"}>{row.status}</button>
                        </TableCell>
                        <TableCell>
                          <div className="actBtnGrps">
                            {
                              [DRAFT, PENDING, REJECTED, LIVE].includes(row.status) && states?.permissions?.campaign?.edit === 1 &&
                              < span className="editIcon" onClick={() => {
                                updateFormData(row);
                              }}>Edit</span>
                            }
                            <span className="viewIcon" onClick={() => {
                              navigate(`/campaign/partial/details/${row.id}`, { state: row.type });
                            }}>
                              View
                            </span>
                            {![LIVE].includes(row.status) && states?.permissions?.campaign?.delete == 1 &&
                              <span className="viewIcon" style={{ color: "red" }} onClick={() => {
                                setDeleteOpen(row.id)
                              }}>
                                Delete
                              </span>}
                          </div>
                        </TableCell>
                      </TableRow >
                    );
                  })
                ) : (
                  <TableRow colSpan={11}>
                    <TableCell colSpan={11} style={{ textAlign: 'center', height: "250px" }}>

                      <Typography
                        color="inherit"
                        variant="subtitle1"
                        alignItems={"center"}
                        component="h3"
                      >
                        No Data found!
                      </Typography>

                    </TableCell>
                  </TableRow>
                )}
              </TableBody >
            </Table >
          </TableContainer>
          <Stack
            sx={{
              background: 'transparent',
              height: '60px',
              border: '1px solid #E9EAEB'
            }}
            direction="row"
            alignItems={"center"}
            justifyContent={"flex-end"}>
            <CustomPagination
              count={Math.ceil(totalPages / limit) || 0}
              onChange={handleChange}
              currentPage={page}
              handleChangePerPage={handleChangePerPage}
              limit={limit}
              listingCount={campaignListing?.length}
              totalCount={totalCount}
              defaultPage={1} siblingCount={1} boundaryCount={1} />
          </Stack>
        </Box >
      </Stack >
      <CommonModel
        open={deleteOpen}
        handleDialogClose={() => setDeleteOpen(false)}
        dialogTitle={"Delete Campaign"}
        className={"btnDanger"}
        dialogPara={`Are you sure you want to delete this campaign? `}
        nvYes={"Delete"}
        nvCancel={"Cancel"}
        yesHandle={() => {
          dispatch(deleteCampaign(deleteOpen));
          setDeleteOpen(false);
        }}
      />

    </>
  );
}
